module.exports = __webpack_public_path__ + "static/media/boxing-2.a702b7a3.png";